import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicPage from './pages/PublicPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/*
          All public URLs — including / — are resolved by the backend resolver.
          No orgSlug in the URL. Org is configured via PUBLIC_ORG_SLUG env.

          Prefixed mode:
            /:eventSlug              → EventPage
            /:eventSlug/:formSlug    → FormPage

          Flat mode:
            /                        → EventPage (event at root)
            /:formSlug               → FormPage

          Standalone forms (any mode):
            /:formSlug               → FormPage (no event prefix)

          Not-found is handled inside PublicPage when the resolver returns
          a not_found result or a network error.
        */}
        <Route path="/*" element={<PublicPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;